

const SEGdemographics = ({
    pageTitle,
    Header,
    currentPage,
    Back,
    handleBackClick,
    pageRef,
    SegLogoBanner,
    logo,
    FormInput,
    TextInput,
    SelectInput,
    DynamicCheckbox,
    MedicalPortalAccess,
    Paragraph,
    ButtonGroup,
    FaTrash,
    FaPlus,
    PatientRegistrationFormData,
    setPatientRegistrationFormData,
    handleInputChange,
    handlePortalChange,
    handleZipSearch,
    handleFamilyContentChange,
    handleRemoveFamilyMember,
    handleAddMember,
    genderOptions,
    languageOptions,
    ethnicityOptions,
    maritalOptions,
    raceOptions,
    emergencyRelationshipOptions,
    invalidFields,
    nextLoader,
    isSubmitted,
    fileUpload,
    handleEdit,
    handleNext,
    handleFormSubmit,
    validateForm,
    Signature,
    signatures,
    canvasRefs,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    isEditing,
    formattedDate,
    showAllPages,
    handleCheckboxChange,
    SegFooter,
    handleCheckChange,
    DOBPickerInput,
    FamilyMemberConsent,
    show,
    ABN,
    SegimageConsentForm,
    RadioGroup,
    HeaderTitle,
    imagingOptions,
    refractionsOptions,
    age,
    showPatientSignaturePage4,
    showPatientSignaturePage5,
    showPatientSignaturePage6,
    setShowPatientSignaturePage5,
    setShowPatientSignaturePage6,
    setShowPatientSignaturePage4,
    abnRef,
    optosRef,
    optosHeader,
    optos,
    Logo,
    Agree
}) => {
    return (
        <>
            <Header pageTitle={pageTitle} />
            <form className="bg-white">
                {(
                    (currentPage > 1 && !show) ||
                    (currentPage !== 5 && show)
                ) && (
                        <Back onClick={handleBackClick} />
                    )}
                <div ref={pageRef} className={`
                            bg-white w-full
                            ${!showAllPages ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                    style={{ transformOrigin: "top left" }}
                >


                    {
                        (currentPage === 1 || showAllPages) && (
                            <div className={`px-20 py-2`}>
                                <SegLogoBanner src={logo} />

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>
                                    {[
                                        {
                                            id: "firstName",
                                            label: "First Name",
                                            required: true,
                                        },
                                        {
                                            id: "lastName",
                                            label: "Last Name",
                                            required: true,
                                        }
                                    ].map(({ id, label, required }) => (
                                        <FormInput
                                            key={id}
                                            id={id}
                                            label={label}
                                            type="text"
                                            labelPosition="top"
                                            disabled={nextLoader || showAllPages}
                                            value={PatientRegistrationFormData[id]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes(label) && !PatientRegistrationFormData[id]}
                                            required={required}
                                        />
                                    ))}
                                    {/* DOB */}
                                    <DOBPickerInput
                                        id="dob"
                                        label="DOB"
                                        value={PatientRegistrationFormData.dob}
                                        onChange={(date) => {
                                            const formattedDate = date
                                                ? `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date
                                                    .getDate()
                                                    .toString()
                                                    .padStart(2, "0")}/${date.getFullYear()}`
                                                : "";
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                dob: formattedDate,
                                            }));
                                        }}
                                        disabled={nextLoader}
                                        invalid={invalidFields.includes("DOB")}
                                        required={true}
                                    />

                                </div>

                                {/* Address */}
                                <TextInput
                                    id="address"
                                    label="Address"
                                    required
                                    value={PatientRegistrationFormData.address}
                                    onChange={handleInputChange}
                                    disabled={nextLoader}
                                    invalid={invalidFields.includes("Address") && !PatientRegistrationFormData.address}
                                />

                                <div className="flex flex-wrap">
                                    {/* City */}
                                    <div className="flex flex-col justify-center w-full sm:w-1/3">
                                        <p className="text-sm font-semibold text-gray-600">City</p>
                                        <p className="text-lg text-gray-800">{PatientRegistrationFormData.city}</p>
                                    </div>

                                    {/* State */}
                                    <div className="flex flex-col justify-center w-full sm:w-1/3">
                                        <p className="text-sm font-semibold text-gray-600">State</p>
                                        <p className="text-lg text-gray-800">{PatientRegistrationFormData.state}</p>
                                    </div>

                                    {/* Zip Code */}
                                    <div className="flex flex-col justify-center w-full sm:w-1/3">
                                        <FormInput
                                            id="zip"
                                            label="Zip"
                                            type="text"
                                            disabled={nextLoader}
                                            labelPosition="top"
                                            value={PatientRegistrationFormData.zip}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("zip") && !PatientRegistrationFormData.zip}
                                            required
                                            onZipSearch={handleZipSearch}
                                            className="border border-gray-300 rounded-md p-2 text-sm text-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 transition duration-200 ease-in-out"
                                        />
                                    </div>
                                </div>


                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                    <SelectInput
                                        id="maritalStatus"
                                        label="Marital Status"
                                        options={maritalOptions}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData.maritalStatus}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                maritalStatus: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("maritalStatus")}
                                        errorMessage="Please select a marital status."
                                    />

                                    {/* ssn */}

                                    <FormInput
                                        key="ssn"
                                        id="ssn"
                                        label="Social Security Number"
                                        type="number"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["ssn"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("SSN")}
                                        required={false}
                                    />
                                </div>

                                <Paragraph>We may use your phone number for appointment reminders and care-related communication.</Paragraph>

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>
                                    {/* cellphone */}
                                    <FormInput
                                        key="cellphone"
                                        id="cellphone"
                                        label="Cell Phone"
                                        type="number"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["cellphone"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Cell Phone") && !PatientRegistrationFormData["cellphone"]}
                                        required={true}
                                    />


                                    <FormInput
                                        key="homenumber"
                                        id="homenumber"
                                        label="Home Phone"
                                        type="number"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["homenumber"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Home Phone") && !PatientRegistrationFormData["homenumber"]}
                                        required={true}
                                    />

                                    <FormInput
                                        key="worknumber"
                                        id="worknumber"
                                        label="Work Phone"
                                        type="number"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["worknumber"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Work Phone") && !PatientRegistrationFormData["worknumber"]}
                                        required={false}
                                    />



                                </div>

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>

                                    <SelectInput
                                        id="gender"
                                        label="Gender *"
                                        labelPosition="top"
                                        options={genderOptions}
                                        value={PatientRegistrationFormData.gender}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                gender: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("Gender") && !PatientRegistrationFormData.gender}
                                        errorMessage="Please select a gender."
                                    />

                                    <SelectInput
                                        id="preferredLanguage"
                                        label="Preferred Language"
                                        options={languageOptions}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData.language}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                language: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("preferredLanguage") && !PatientRegistrationFormData.language}
                                        errorMessage="Please select a language."
                                    />

                                </div>

                                <div className="text-sm text-muted-foreground mt-1 mb-2 gap-4 flex-row">


                                    {/* reminderPhone */}
                                    <DynamicCheckbox
                                        label="Yes, I agree to receive occasional text messages from Southern Eye Group about updates, services, and events. Message and data rates may apply. Message frequency varies. I understand that I can opt-out at any time."
                                        fieldName="consentToText"
                                        id="consentToText"
                                        isChecked={PatientRegistrationFormData.consentToText}
                                        onChange={handleCheckChange}
                                        isDisabled={nextLoader}
                                        showError={invalidFields.includes("consentToText")}
                                    />
                                </div>

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                    <SelectInput
                                        id="ethnicity"
                                        label="Ethnicity"
                                        options={ethnicityOptions}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData.ethnicity}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                ethnicity: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("ethnicity")}
                                    />

                                    <SelectInput
                                        id="race"
                                        label="Race"
                                        options={raceOptions}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData.race}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                race: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("race")}
                                        errorMessage="Please select a race."
                                    />
                                </div>

                            </div>
                        )
                    }

                    {
                        (currentPage === 2 || showAllPages) && (
                            <div className={`px-20 py-2`}>


                                <div className="border-t-4 border-b-4 border-gray-300 p-3">
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-md font-semibold text-center text-black">
                                        Emergency Contact Information
                                    </p>
                                </div>


                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>
                                    {/* Name */}

                                    <FormInput
                                        key="emergencyName"
                                        id="emergencyName"
                                        label="Name"
                                        type="text"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["emergencyName"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Name")}
                                        required={false}
                                    />

                                    {/* relationship */}
                                    <SelectInput
                                        id="emergencyRelationship"
                                        label="Relationship"
                                        labelPosition="top"
                                        options={emergencyRelationshipOptions}
                                        value={PatientRegistrationFormData.emergencyRelationship}
                                        onChange={(e) =>
                                            setPatientRegistrationFormData((prev) => ({
                                                ...prev,
                                                emergencyRelationship: e.target.value,
                                            }))
                                        }
                                        disabled={nextLoader || showAllPages}
                                        invalid={invalidFields.includes("Emergency Relationship")}
                                        errorMessage="Please select a emergency relationship."
                                    />
                                    <FormInput
                                        key="emergencyPhone"
                                        id="emergencyPhone"
                                        label="Phone"
                                        type="number"
                                        labelPosition="top"
                                        disabled={isSubmitted}
                                        value={PatientRegistrationFormData["emergencyPhone"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Emergency Phone")}
                                        required={false}
                                    />
                                </div>

                                <div className="border-t-4 border-b-4 border-gray-300 p-3">
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-md font-semibold text-center text-black">
                                        Family Doctor
                                    </p>
                                </div>

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>


                                    {/* family doctor */}
                                    <FormInput
                                        key="familyDoctor"
                                        id="familyDoctor"
                                        label="Family Doctor"
                                        type="text"
                                        labelPosition="top"
                                        disabled={nextLoader || showAllPages}
                                        value={PatientRegistrationFormData["familyDoctor"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Family Doctor")}
                                        required={false}
                                    />

                                    {/* family doctor */}
                                    <FormInput
                                        key="familyDoctorph"
                                        id="family_ph_no"
                                        label="Phone Number"
                                        type="text"
                                        labelPosition="top"
                                        disabled={nextLoader || showAllPages}
                                        value={PatientRegistrationFormData["family_ph_no"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Family Doctor Phone Number")}
                                        required={false}
                                    />

                                    <FormInput
                                        key="familyDoctorfax"
                                        id="family_fax_no"
                                        label="Fax Number"
                                        type="text"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["family_fax_no"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Family Doctor Fax Number")}
                                        required={false}
                                    />
                                </div>

                                <div className="border-t-4 border-b-4 border-gray-300 p-3">
                                    {/* Emergency Contact Information Heading */}
                                    <p className="text-md font-semibold text-center text-black">
                                        Referral Information
                                    </p>
                                </div>

                                <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-3" : "grid-cols-1 sm:grid-cols-3"}`}>


                                    {/* family doctor */}
                                    <FormInput
                                        key="referredBy"
                                        id="referredBy"
                                        label="Referred By"
                                        type="text"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["referredBy"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Referred By")}
                                        required={false}
                                    />

                                    {/* family doctor */}
                                    <FormInput
                                        key="referredByPh"
                                        id="referrer_ph_no"
                                        label="Phone Number"
                                        type="text"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["referrer_ph_no"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Referred By Phone Number")}
                                        required={false}
                                    />

                                    <FormInput
                                        key="referredByFax"
                                        id="referrer_fax_no"
                                        label="Fax Number"
                                        type="text"
                                        disabled={nextLoader || showAllPages}
                                        labelPosition="top"
                                        value={PatientRegistrationFormData["referrer_fax_no"]}
                                        onChange={handleInputChange}
                                        invalid={invalidFields.includes("Referrer Fax Number")}
                                        required={false}
                                    />
                                </div>

                                <Paragraph>We use your email to send important information related to your care, including appointment confirmations, forms, and follow-up instructions.</Paragraph>

                                <TextInput
                                    id="email"
                                    label="Email"
                                    labelPosition="top"
                                    value={PatientRegistrationFormData.email}
                                    onChange={handleInputChange}
                                    disabled={nextLoader || showAllPages}
                                    invalid={invalidFields.includes("Email") && !PatientRegistrationFormData.email}
                                />
                                {
                                    Boolean(PatientRegistrationFormData?.email?.trim()) && (
                                        <div className="text-sm text-muted-foreground mt-1 mb-2 gap-2 flex-row">
                                            <DynamicCheckbox
                                                label="Yes, I would like to receive occasional updates from Southern Eye Group, including helpful eye care information, new services, and practice updates. I understand I can unsubscribe at any time."
                                                fieldName="emailConsent"
                                                id="emailConsent"
                                                isChecked={PatientRegistrationFormData.emailConsent}
                                                onChange={handleCheckChange}
                                                isDisabled={nextLoader}
                                                showError={invalidFields.includes("emailConsent")}
                                            />
                                        </div>
                                    )
                                }

                                {/* Portal */}
                                <MedicalPortalAccess
                                    label="Would you like to have access to your Medical Records / Portal?"
                                    id="portal"
                                    portalValue={PatientRegistrationFormData.portal}
                                    onChange={handlePortalChange}
                                    isDisabled={nextLoader}
                                />

                                {/* Portal */}
                                <MedicalPortalAccess
                                    label="Would you like to subscribe to our email newsletter?"
                                    id="subscription"
                                    portalValue={PatientRegistrationFormData.subscription}
                                    onChange={handlePortalChange}
                                    isDisabled={nextLoader}
                                />
                                <Paragraph>We promise not to inundate you with emails and respect your privacy.
                                </Paragraph>

                                <div>
                                    {invalidFields.includes('emergencyFields') && (
                                        <p style={{ color: 'red' }}>Fill out all the fields in the emergency contact information!</p>
                                    )}
                                </div>
                                <div>
                                    <div className="border-t-4 border-b-4 border-gray-300 p-3">
                                        {/* Emergency Contact Information Heading */}
                                        <p className="text-md font-semibold text-center text-black">
                                            Insurance Details
                                        </p>
                                    </div>

                                    <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>

                                        <FormInput
                                            key="insuranceProvider"
                                            id="insurance_provider"
                                            label="Insurance Provider"
                                            type="text"
                                            disabled={nextLoader || showAllPages}
                                            labelPosition="top"
                                            value={PatientRegistrationFormData["insurance_provider"]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("Insurance Provider")}
                                            required={false}
                                        />

                                        <FormInput
                                            key="policyNumber"
                                            id="policy_number"
                                            label="Policy Number"
                                            type="text"
                                            disabled={nextLoader || showAllPages}
                                            labelPosition="top"
                                            value={PatientRegistrationFormData["policy_number"]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("Policy Number")}
                                            required={false}
                                        />


                                    </div>
                                    <div className={`my-2 grid gap-3 ${showAllPages ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                                        <FormInput
                                            key="subscriber_name"
                                            id="subscriber_name"
                                            label="Subscriber Name"
                                            type="text"
                                            disabled={nextLoader || showAllPages}
                                            labelPosition="top"
                                            value={PatientRegistrationFormData["subscriber_name"]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("Subscriber Name")}
                                            required={false}
                                        />
                                        <FormInput
                                            key="subscriber_dob"
                                            id="subscriber_dob"
                                            label="Subscriber DOB"
                                            type="text"
                                            disabled={nextLoader || showAllPages}
                                            labelPosition="top"
                                            value={PatientRegistrationFormData["subscriber_dob"]}
                                            onChange={handleInputChange}
                                            invalid={invalidFields.includes("Subscriber DOB")}
                                            required={false}
                                        />
                                    </div>

                                </div>

                            </div>
                        )
                    }
                    {(currentPage === 3 || showAllPages) &&
                        (<div className={`px-20 py-2`}>
                            <FamilyMemberConsent
                                familyMembers={PatientRegistrationFormData.familyMembers}
                                handleFamilyChange={handleFamilyContentChange}
                                handleAddMember={handleAddMember}
                                handleRemoveFamilyMember={handleRemoveFamilyMember}
                                DOBPickerComponent={DOBPickerInput} // pass your component
                                fileUpload={nextLoader || showAllPages}
                                nextLoader={nextLoader || showAllPages}
                                FaTrash={FaTrash}
                                FaPlus={FaPlus}
                                title={'Southern Eye Group'}
                            />

                            <div className="w-full rounded-lg bg-white p-4 grid grid-cols-2 items-center gap-4">
                                {/* Left side: Date */}

                                <div className="text-left">

                                    <Agree
                                        showAgreement={showPatientSignaturePage5}
                                        setShowAgreement={setShowPatientSignaturePage5}
                                        signatureField={"patient_signature"}
                                        formData={PatientRegistrationFormData}
                                        title={"Patient/Responsible Party Signature"}
                                    />
                                </div>

                                {/* Right side: Signature */}
                                <div className="text-right">
                                    {formattedDate}
                                </div>
                            </div>


                            <div className=" bg-white mx-auto">
                                <label
                                    htmlFor="lasik"
                                    className="block font-bold col-span-1 mb-4"
                                >
                                    Are you interested in Laser Vision Correction / LASIK?{" "}
                                    <span className="text-red-500">*</span>
                                </label>                                {Object.keys(PatientRegistrationFormData.lasik).map((key) => (
                                    <div key={key} className="flex space-x-3 mb-2">
                                        <input
                                            type="checkbox"
                                            id={key}
                                            disabled={nextLoader || showAllPages}
                                            checked={PatientRegistrationFormData.lasik[key] === true}
                                            onChange={() => handleCheckboxChange("lasik", key, !PatientRegistrationFormData.lasik[key])}
                                            className="form-checkbox h-5 w-5 text-sky-600 border-gray-300 rounded"
                                        />
                                        <label htmlFor={key} className="text-black font-medium">{key}</label>
                                    </div>
                                ))}
                            </div>
                            <SegFooter />
                        </div>
                        )}


                </div>

                {/* Page 4 */}
                {(currentPage === 4 && show) && (

                    <div
                        ref={abnRef}
                        className={`
                            bg-white w-full
                            ${!nextLoader ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <SegLogoBanner src={logo} />


                        <ABN />

                        <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-4 my-2">
                            <FormInput
                                key="printedName"
                                id="printedName"
                                label="Printed Name"
                                type="text"
                                disabled={true}
                                value={PatientRegistrationFormData["firstName"] + " " + PatientRegistrationFormData["lastName"]}
                                invalid={invalidFields.includes("Printed Name")}
                            />
                            <FormInput
                                key="formattedDate"
                                id="formattedDate"
                                label="Formatted Date"
                                type="text"
                                disabled={true}
                                value={PatientRegistrationFormData.signed_date}
                                invalid={invalidFields.includes("Formatted Date")}
                            />
                        </div>


                        <div className={`my-4 grid gap-3 ${nextLoader ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                            <div className="w-full rounded-lg bg-white">

                                <Agree

                                    showAgreement={showPatientSignaturePage5}
                                    setShowAgreement={setShowPatientSignaturePage5}
                                    signatureField={"patient_signature"}
                                    formData={PatientRegistrationFormData}
                                    title={"Patient/Responsible Party Signature"}
                                />
                            </div>

                        </div>
                        <div className="border-2 border-gray-300 rounded-md my-2">
                            <p className="bg-gray-200 text-black font-semibold p-2 rounded-t-md text-center justify-center">Prescription Options</p>
                            <RadioGroup
                                label=""
                                name="refractions"
                                disabled={fileUpload}
                                selectedValue={PatientRegistrationFormData.refractions || ""}
                                onChange={(value) => {
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        refractions: value,
                                    }));
                                }}
                                options={refractionsOptions}
                                stacked={true}
                            />

                        </div>
                        <div className="my-2">
                            <SegFooter />
                        </div>
                    </div>

                )}
                {/* Page 5 */}
                {(currentPage === 5 && show) && (

                    <div
                        ref={optosRef}
                        className={`
                            bg-white w-full
                            ${!fileUpload ? "max-w-6xl" : "w-[1200px] mx-auto"} 
                        `}
                        style={{ transformOrigin: "top left" }}
                    >
                        <SegLogoBanner src={logo} />

                        <SegimageConsentForm Paragraph={Paragraph} optos={optos} optosHeader={optosHeader} Logo={Logo} />
                        <div className="border-2 border-gray-300 rounded-md my-2">
                            <p className="bg-gray-200 text-black font-semibold p-2 rounded-t-md">Please choose one of the following:</p>
                            <RadioGroup
                                label=""
                                name="imaging_options"
                                disabled={fileUpload}
                                selectedValue={PatientRegistrationFormData.imaging_options || ""}
                                onChange={(value) => {
                                    console.log("Selected imaging option:", value);
                                    setPatientRegistrationFormData((prev) => ({
                                        ...prev,
                                        imaging_options: value,
                                    }));
                                }}
                                options={imagingOptions}
                            />
                        </div>
                        <div className={`my-4 grid gap-3 ${fileUpload ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                            <FormInput
                                key='printedName'
                                id='printedName'
                                label='Printed Name'
                                type="text"
                                disabled={true}
                                value={PatientRegistrationFormData.firstName + " " + PatientRegistrationFormData.lastName}
                                onChange={handleInputChange}
                                invalid={false}
                                required={false}
                            />
                            <FormInput
                                key='date'
                                id='date'
                                label='Date'
                                type="text"
                                disabled={true}
                                value={formattedDate}
                                onChange={handleInputChange}
                                invalid={false}
                                required={false}
                            />
                        </div>

                        <div className={`my-4 grid gap-3 ${fileUpload ? "grid-cols-2" : "grid-cols-1 sm:grid-cols-2"}`}>
                            <div className="w-full rounded-lg bg-white">
                                <div className="mb-2 grid grid-cols-1 sm:grid-cols-2 gap-2">

                                    <Agree
                                        showAgreement={showPatientSignaturePage5}
                                        setShowAgreement={setShowPatientSignaturePage5}
                                        signatureField={"patient_signature"}
                                        formData={PatientRegistrationFormData}
                                        title={"Patient/Responsible Party Signature"}
                                    />
                                </div>

                            </div>
                        </div>

                        <div className="my-2">
                            <SegFooter />
                        </div>
                    </div>
                )}
                <div className="mt-10">
                    <ButtonGroup
                        isSubmitted={isSubmitted}
                        currentPage={currentPage}
                        handleEdit={handleEdit}
                        handleNext={handleNext}
                        handleFormSubmit={handleFormSubmit}
                        validateForm={validateForm}
                    /></div>
            </form >
        </>
    );
};

export default SEGdemographics;


